module.exports = __webpack_public_path__ + "static/img/bg.25f1321.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/questionnaire/bg.png
// module id = PDmc
// module chunks = 1